import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { withSuperJSONPage as _withSuperJSONPage } from "babel-plugin-superjson-next/tools";
import BacklinksWrapper from 'apps/exegesis/components/NBacklinksWrapper';
import { ReadOnlyDisplay } from 'apps/exegesis/components/SlateEditor/usedPlugins';
import Head from 'next/head';
import Link from 'next/link';
import React, { useRef } from 'react';
import styled from 'styled-components';
import PublicLayout from '../../components/PublicLayout';
import { TagsAndTagInputRow } from '../../components/SlateEditor/NoteControls';
import { CreateMentionSlateComponent } from '../../components/SlateEditor/plugins/TagMentionSlateComponent';
import { NoteIdContext } from '../../components/SlateEditor/SlateEditorWrapper';
import { useFetcher } from '../../utils/DataFetchers';
import { useAndSetAuthor } from '../../utils/useAuthor';
import Custom404 from '../404';
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: 80%;\n  max-width: 800px;\n  margin: auto;\n  margin-bottom: 10vh;\n\n  font-size: 20px;\n  line-height: 1.42;\n\n  img {\n    object-fit: contain;\n    max-width: 100%;\n  }\n  .slate-p {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: inline-block;\n  font-size: 12px;\n  padding: 3px;\n  margin: 2.5px 2.5px 5px 2.5px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var MentionComponent = CreateMentionSlateComponent(true);
var dateFormatter = new Intl.DateTimeFormat('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
});
function PublicNote(props) {
    var scrollContainerRef = useRef(null);
    useFetcher([
        'NoteById',
        {
            note_id: props.noteId,
            note_public: null,
            note_author: null,
            note_title: null
        }
    ], {
        // enable it on public notes only
        // because the note will not have been fetched yet
        enabled: false,
        // staleTime: Infinity,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        initialData: props.fullNoteResult
    });
    var author = useAndSetAuthor(props.author);
    if (props.published === false) {
        return(/*#__PURE__*/ _jsx(Custom404, {}));
    }
    return(/*#__PURE__*/ _jsxs(ScrollContainer, {
        ref: scrollContainerRef,
        children: [
            /*#__PURE__*/ _jsx(Head, {
                children: /*#__PURE__*/ _jsx("title", {
                    children: props.title
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                style: {
                    paddingLeft: '0.5rem'
                },
                children: [
                    /*#__PURE__*/ _jsx("h1", {
                        children: props.title || 'untitled note'
                    }),
                    /*#__PURE__*/ _jsx("i", {
                        children: /*#__PURE__*/ _jsx(Link, {
                            href: '/user/' + props.author,
                            children: props.username
                        })
                    }),
                    ' ',
                    /*#__PURE__*/ _jsx("i", {
                        children: dateFormatter.format(new Date(props.creationDate)).toLowerCase()
                    }),
                    /*#__PURE__*/ _jsx(TagsAndTagInputRow, {
                        children: props.noteTags.map(function(tag) {
                            return(/*#__PURE__*/ _jsx("span", {
                                style: {
                                    marginRight: '5px',
                                    marginBottom: '5px',
                                    display: 'inline-block'
                                },
                                children: /*#__PURE__*/ _jsx(MentionComponent, {
                                    attributes: {},
                                    element: {
                                        value: tag
                                    }
                                })
                            }, tag));
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(NoteIdContext.Provider, {
                value: props.noteId,
                children: /*#__PURE__*/ _jsx(ReadOnlyDisplay, {
                    nodes: props.noteContent,
                    isRoot: true
                })
            }),
            props.initialExcerpts.length > 0 || props.notesWithTag.length > 0 ? /*#__PURE__*/ _jsx(BacklinksWrapper, {
                initialTags: [
                    props.title || ''
                ],
                initialExcerpts: props.initialExcerpts,
                initialNotes: props.notesWithTag,
                containerRef: scrollContainerRef,
                open: false,
                public: true,
                isRoot: true
            }) : null
        ]
    }));
}
var ScrollContainer = styled.div(_templateObject(), function(props) {
    return props.theme.fontSize;
});
var Tag = styled.span(_templateObject1(), function(props) {
    return props.theme.colors.main.light;
});
PublicNote.layout = PublicLayout;
export var __N_SSG = true;
export default _withSuperJSONPage(PublicNote);
